import { FilledButton } from "@/components/ui/buttons";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface SearchActionButtonProps {
  onSearch: () => void;
}

export const SearchActionButton = memo(function SearchActionButton({
  onSearch,
}: SearchActionButtonProps) {
  return (
    <div className="mt-2 flex h-[338px] flex-col items-center justify-center gap-4">
      <p className={cn(textVariants.headline, "h-11.5")}>Tap to Search</p>
      <FilledButton
        onClick={onSearch}
        color="black"
        className="bg-screen-gs-1 w-48"
        textCase="normal"
      >
        Search Foods
      </FilledButton>
    </div>
  );
});
